import React from "react";
import { useState } from "react";
import { useEvalNat } from "../../hooks/fetch_api_hook/useEvalNat";
import { useParams } from "react-router-dom";
import { useClasseContext } from "../../context/ClasseContext";
import MultiSelect from "../general/MultiSelect";
import { useUser } from "../../context/UserContext";
import { useMemo } from "react";
import Loading from "../general/Loading";
import { Users , Settings , BookOpen , FileText , CheckCircle, Info, Loader2
} from "lucide-react";
import PilotageHeader from "../general/PilotageHeader";
import { classesAvecCopies, niveauDe } from "../../utils/campagneEvalNat";
function FormGroup({handleNationalEval, typeEval, handleAutomatismesChange,handleTypeEvalChange, handleProblemesChange,  labelAutomatismesNat
     , labelProblèmesNat , labelLexiqueNat, labelCompetencesLangagieresNat, labelComprehensionEcriteNat,
    handleLexiqueChange, selectedLexique,  handleCompetencesChange, selectedCompetences, handleComprehensionChange, selectedComprehension,
     handleNbGroupeChange, selectedAutomatismes, selectedProblemes,listGroupes,
     nbGroupes, handleSubmit, elevesNonAffectes, listEvalClasse , selectedEvalClasse, handleEvalClasseChange,
     selectedBarette}){

      const {idclasse} = useParams()
      const {user} = useUser()
    const {classeNom, groupNom} = useClasseContext(); // On recupère le nom de la classe depuis le context (initialisé également à la selection du menu)
    const [conserverGroupes, setConserverGroupes] = useState(false); // Nouveau état pour conserver les groupes
    const {etablissementData} = useUser();
    const handleModeChange = (e) => {
      setConserverGroupes(e.target.value === "conserver"); // Mettre à jour l'état selon le choix
    };
  
    const { data: EvalsNatEtablissement, isLoading: isLoadingEvalNat } = useEvalNat(
      etablissementData?.id && !idclasse ? `?etablissement_id=${parseInt(etablissementData.id, 10)}` : `?classes_pk=${parseInt(idclasse, 10)}`,
      null,
      null,
      (!etablissementData?.id && classeNom !== "") && "not-enabled"
  );

const hasEmptyGroup = (listgroupes) => {
  if (!listgroupes || !Array.isArray(listgroupes)) {
    return false;
  }
  
  return listgroupes.some(groupe => 
    !groupe.eleves || groupe.eleves.length === 0
  );
};
 // Utiliser useMemo pour calculer les évaluations filtrées
 const evalfiltered = useMemo(() => {
  if (!groupNom) {
    // **Contexte du chef d'établissement**
    if (EvalsNatEtablissement && EvalsNatEtablissement.length > 0) {
      // Le niveau de la barrette (ou de la classe) ; une campagne porte le sien, sans nom de classe (D9)
      const niveauVoulu = listGroupes.length > 0 ? listGroupes[0].classes_detail[0][0] : classeNom[0];
      const eval_nat_sixieme = EvalsNatEtablissement.filter((evalnat) => niveauDe(evalnat) === niveauVoulu)
      return (eval_nat_sixieme)
    } else {
      return [];
    }
 

  }
},[EvalsNatEtablissement, groupNom, classeNom,listGroupes])
 

const isFullEvalNat = useMemo(() => {
  if(classeNom && evalfiltered.length >0) {
    return true;
  }
  // Vérifie si `listGroupes` et `evalfiltered` contiennent des données
  if (listGroupes.length > 0 && evalfiltered.length > 0) {
  // Vérification : chaque classe de la barrette a ses résultats nationaux, une évaluation à son nom ou des
  // copies dans la campagne du niveau (D9). Un bilan ne suffit pas (défaut 12).
const classesImportees = classesAvecCopies(evalfiltered);
const result = listGroupes[0]?.classes_detail.every(classeDetail => classesImportees.has(classeDetail));
return result;
  }

  // Si l'un des tableaux est vide, retourne false
  return false;
}, [listGroupes, evalfiltered, classeNom]);
// En haut de ton composant
const isDisabled = hasEmptyGroup(listGroupes);

// Vérifier si au moins un élève est déjà affecté à un groupe de cette barrette
const hasElevesAffectes = listGroupes?.some(groupe => groupe.eleves && groupe.eleves.length > 0);


    return (
        <div>

                 <>
        {/* En-tête standard Pilotage (mode classe uniquement — le flux barrette n'affiche pas de bandeau ici).
            Mêmes gouttières que la page Savoirs : px-4 + p-2, pleine largeur. */}
        {classeNom && (
          <div className="px-4 p-2">
            <PilotageHeader
              icone={Users}
              titre="Groupes de besoins"
              sousTitre={"Classe de " + classeNom}
              badgeNiveau={classeNom?.charAt(0)}
            />
          </div>
        )}
        {!classeNom && <br/>}

      {/* Carte principale du formulaire */}
        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 xl:p-6 2xl:p-8 3xl:p-10 max-w-7xl mx-auto">


       {/* Section: Critères de composition */}
          <div className="mb-8 xl:mb-6 2xl:mb-7 3xl:mb-8">
            <div className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6">
              <div className="w-10 h-10 xl:w-8 xl:h-8 2xl:w-9 2xl:h-9 3xl:w-10 3xl:h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <Settings className="text-blue-600 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
              </div>
              <div>
                <h2 className="text-xl sm:text-2xl xl:text-lg 2xl:text-xl 3xl:text-2xl font-bold text-gray-800">
                  Critères de composition du groupe
                </h2>
                {selectedBarette?.length > 0 && (
                  <p className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-500 mt-1">
                    Barrette : <span className="font-medium text-blue-600">{selectedBarette.join(', ')}</span>
                  </p>
                )}
              </div>
            </div>

            {/* Texte explicatif */}
            <p className="text-gray-600 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4 text-sm sm:text-base xl:text-xs 2xl:text-sm 3xl:text-base">
              Composez vos groupes à partir des résultats de votre choix :
            </p>

       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 xl:gap-3 2xl:gap-4 3xl:gap-6">
        { ((classeNom?.[0] === '6' || classeNom?.[0] === '4' || classeNom?.[0] ==='5') ||
  (selectedBarette?.length > 0 && (selectedBarette[0]?.[0] === '6' || selectedBarette[0]?.[0] === '4' || selectedBarette[0]?.[0] === '5')))
 &&
        <RenderFormEvalNat
            evalfiltered={evalfiltered}
            isFullEvalNat={isFullEvalNat}
            handleNationalEval={handleNationalEval}
            isLoading={isLoadingEvalNat}
          />
        }
     
{ /*  <div className="flex items-center space-x-3 border shadow-lg rounded-3xl p-5  w-1/3  ">
    <input type="radio" id="evaluationBilan" name="critereEvaluation" value="EvaluationBilan" className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 focus:ring-green-500 dark:focus:ring-green-600" 
    onChange={(e) => handleTypeEvalChange(e,evalfiltered)}/>
    <label for="evaluationBilan" className="flex-1 min-w-0">
      <span className="block text-lg font-medium text-gray-900 dark:text-gray-300">Évaluation Bilan</span>
      <span className="block text-xs text-gray-500">Les évaluations bilan données pour mesurer les progrès de l'évaluation nationale seront selectionnable pour composer vos groupes.</span>
    </label>
  </div> 
  */ }
  
  
              {/* Option Évaluations en classe */}
              <div className="group relative bg-white border-2 border-gray-200 rounded-xl p-5 sm:p-6 xl:p-4 2xl:p-5 3xl:p-6 hover:border-blue-400 hover:shadow-lg transition-all duration-300">
                <div className="flex items-start gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
                  <input
                    type="radio"
                    id="evaluationsEnClasse"
                    name="critereEvaluation"
                    value="EvaluationsEnClasse"
                    className="mt-1 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-blue-600 border-2 border-gray-300 focus:ring-2 focus:ring-blue-500"
                    onChange={handleTypeEvalChange}
                  />
                  <label htmlFor="evaluationsEnClasse" className="flex-1 cursor-pointer">
                    <div className="flex items-center gap-2 mb-2 xl:mb-1.5 2xl:mb-1.5 3xl:mb-2">
                      <BookOpen className="text-blue-500 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                      <span className="text-lg xl:text-sm 2xl:text-base 3xl:text-lg font-semibold text-gray-900">
                        Évaluations en classe
                      </span>
                    </div>
                    <span className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-600 leading-relaxed">
                      Evaluation donnée en classe noté par compétences.
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
         
         
          { (typeEval==="EvaluationNationale" && user && user.matiere==="maths" && Object.keys(labelAutomatismesNat)) &&
          <div className="xl:text-sm 2xl:text-base 3xl:text-xl text-lg flex flex-col gap-5 xl:gap-3 2xl:gap-4 3xl:gap-5">
        <p className="font-bold"> Automatisme</p>
        <MultiSelect onChange={handleAutomatismesChange} labels={ labelAutomatismesNat} />

        <p className="font-bold"> Résolutions de problèmes</p>
        <MultiSelect onChange={handleProblemesChange} labels={labelProblèmesNat} />

        {(listGroupes && Object.keys(listGroupes).length === 0)  ? <>  <p className="font-bold"> Nombre de groupes </p>
        <input onChange={handleNbGroupeChange} className="border-black-800 border-2 w-1/4" type="text" placeholder="Ex: 2" />
        </> :
        <div>
          <p className="font-bold"> Nombre de groupes </p>
            <input onChange={handleNbGroupeChange} className="border-black-800 border-2 text-center bg-sky-600 w-fit" type="text" value={Object.keys(listGroupes).length}/>
          </div> }
        {((selectedAutomatismes.length >0 || selectedProblemes.length>0) && nbGroupes) && (
          <>
            <ConservationSection
              hasElevesAffectes={hasElevesAffectes}
              elevesNonAffectes={elevesNonAffectes}
              conserverGroupes={conserverGroupes}
              handleModeChange={handleModeChange}
              isDisabled={isDisabled}
              classeNom={classeNom}
            />
            <div className="text-center">
              <button onClick={() => handleSubmit(false, conserverGroupes ? true : false)}
                className="bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white px-8 xl:px-6 2xl:px-7 3xl:px-8 py-4 xl:py-3 2xl:py-3.5 3xl:py-4 rounded-xl font-bold text-lg xl:text-sm 2xl:text-base 3xl:text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
                <CheckCircle size={20} className="xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                Valider
              </button>
            </div>
          </>
        )}

        </div>}


          { (typeEval==="EvaluationNationale" && user && user.matiere==="Français" && Object.keys(labelLexiqueNat)) &&
          <div className="xl:text-sm 2xl:text-base 3xl:text-xl text-lg flex flex-col gap-5 xl:gap-3 2xl:gap-4 3xl:gap-5">
        <p className="font-bold"> Lexique</p>
        <MultiSelect onChange={handleLexiqueChange} labels={ labelLexiqueNat} />

        <p className="font-bold"> Compréhension écrite </p>
        <MultiSelect onChange={handleComprehensionChange} labels={labelComprehensionEcriteNat} />
             <p className="font-bold"> Compétences langagières </p>
        <MultiSelect onChange={handleCompetencesChange} labels={labelCompetencesLangagieresNat} />

        {(listGroupes && Object.keys(listGroupes).length === 0)  ? <>  <p className="font-bold"> Nombre de groupes </p>
        <input onChange={handleNbGroupeChange} className="border-black-800 border-2 w-1/4" type="text" placeholder="Ex: 2" />
        </> :
        <div>
          <p className="font-bold"> Nombre de groupes </p>
            <input onChange={handleNbGroupeChange} className="border-black-800 border-2 text-center bg-sky-600 w-fit" type="text" value={Object.keys(listGroupes).length}/>
          </div> }
        {((selectedLexique.length >0 || selectedComprehension.length>0 || selectedCompetences.length>0) && nbGroupes) && (
          <>
            <ConservationSection
              hasElevesAffectes={hasElevesAffectes}
              elevesNonAffectes={elevesNonAffectes}
              conserverGroupes={conserverGroupes}
              handleModeChange={handleModeChange}
              isDisabled={isDisabled}
              classeNom={classeNom}
            />
            <div className="text-center">
              <button onClick={() => handleSubmit(false, conserverGroupes ? true : false)}
                className="bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white px-8 xl:px-6 2xl:px-7 3xl:px-8 py-4 xl:py-3 2xl:py-3.5 3xl:py-4 rounded-xl font-bold text-lg xl:text-sm 2xl:text-base 3xl:text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
                <CheckCircle size={20} className="xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                Valider
              </button>
            </div>
          </>
        )}

        </div>}




        { /* typeEval==="EvaluationBilan" && 
        <div>
         {listEvalBilan && 
          
          <div className=" flex flex-col gap-5 mb-5">
            <p className=" font-bold"> Sélectionner l'évaluation Bilan.</p>
            <select value={selectedEvalBilan?.titre || ''} onChange={handleEvalBilanChange} className="border  rounded-3xl p-5 border-black font-bold  focus:border-teal-700 w-1/2">
            <option value="" disabled selected >Sélectionnez une évaluation...</option>
      {listEvalBilan.map((e, index) => (
        <option key={index} value={e.titre} className=" ">
          {e.titre}
        </option>
      ))}
    </select>
            </div>}
          { selectedEvalBilan &&   <div className=" flex flex-col gap-5 mb-5">
        <p className=" font-bold"> Automatisme</p>
            <MultiSelect onChange={handleAutomatismesChange} labels={ labelAutomatismes } />

            <p className=" font-bold"> Problèmes</p>
            <MultiSelect onChange={handleProblemesChange} labels={ labelProblèmes} />

        {(listGroupes && Object.keys(listGroupes).length === 0)  ? <>  <p className=" font-bold"> Nombre de groupes </p>
        <input onChange={handleNbGroupeChange} className=" border-black-800 border-2  w-1/4" type="text" placeholder="Ex: 2" />
        </> :
        <div>
            <input onChange={handleNbGroupeChange} className=" border-black-800 border-2 text-center bg-sky-600 w-fit  " type="text" value={Object.keys(listGroupes).length}/>
          </div> }
        <div className="text-center">
        {((selectedAutomatismes.length >0 || selectedProblemes.length>0) && nbGroupes) &&<button onClick = {()=>handleSubmit(false)} className="button bg-cyan-500 hover:bg-cyan-300 w-fit p-5 rounded-3xl font-bold "> Valider </button>}
        </div> 
            </div>}
          


        
          </div>
          */
          }


        {/* Section: Évaluations en Classe */}
          {typeEval === "EvaluationsEnClasse" && (
            <div className="border-t border-gray-200 pt-8 xl:pt-6 2xl:pt-7 3xl:pt-8 space-y-6 xl:space-y-4 2xl:space-y-5 3xl:space-y-6 animate-fadeIn">
              {listEvalClasse && (
                <div>
                  <div className="flex items-center gap-2 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
                    <FileText className="text-blue-500 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                    <h3 className="text-lg xl:text-sm 2xl:text-base 3xl:text-lg font-bold text-gray-800">Sélectionner l'évaluation en classe</h3>
                  </div>
                  <select
                    value={selectedEvalClasse?.evalTitre || ''}
                    onChange={handleEvalClasseChange}
                    className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-3 xl:py-2 2xl:py-2.5 3xl:py-3 border-2 border-gray-300 rounded-xl text-lg xl:text-xs 2xl:text-sm 3xl:text-lg
                    focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-medium text-gray-700 min-w-[300px] sm:min-w-[400px]"
                  >
                    <option value="" disabled>Sélectionnez une évaluation...</option>
                    {listEvalClasse.map((e, index) => (
                      <option key={index} value={e.evalTitre}>
                        {e.evalTitre}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {/* Nombre de groupes */}
              <div>
                <div className="flex items-center gap-2 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
                  <Users className="text-blue-500 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                  <h3 className="text-lg xl:text-sm 2xl:text-base 3xl:text-lg font-bold text-gray-800">Nombre de groupes</h3>
                </div>
                {(listGroupes && Object.keys(listGroupes).length === 0) ? (
                  <input
                    onChange={handleNbGroupeChange}
                    className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-3 xl:py-2 2xl:py-2.5 3xl:py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-32 text-center font-medium text-base xl:text-xs 2xl:text-sm 3xl:text-base"
                    type="text"
                    placeholder="Ex: 2"
                  />
                ) : (
                  <div className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
                    <input
                      onChange={handleNbGroupeChange}
                      className="px-4 xl:px-3 2xl:px-3.5 3xl:px-4 py-3 xl:py-2 2xl:py-2.5 3xl:py-3 bg-blue-100 border-2 border-blue-300 rounded-xl w-20 text-center font-bold text-blue-700 text-base xl:text-xs 2xl:text-sm 3xl:text-base"
                      type="text"
                      value={Object.keys(listGroupes).length}
                    />
                    <span className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-gray-600">groupes existants</span>
                  </div>
                )}
              </div>
            </div>
          )}

{listEvalClasse.length ===0 && <>
  <div className="mt-5 xl:mt-3 2xl:mt-4 3xl:mt-5 p-4 xl:p-3 2xl:p-3.5 3xl:p-4 bg-orange-100 border border-orange-500 rounded-lg">
              <p className="text-sm xl:text-xs 2xl:text-sm 3xl:text-sm font-semibold text-orange-700">
                Erreurs détectées :
              </p>
              <ul className="text-orange-600 text-sm xl:text-xs 2xl:text-sm 3xl:text-sm list-disc pl-5">

                  <li>
                  <p>
    Aucun devoir commun trouvé ou résultats du devoir commun de cette barrette pas assez nombreux pour créer vos groupes. </p>
                  </li>

              </ul>
            </div>

</>}

{(selectedEvalClasse && nbGroupes) && (
  <>
    <ConservationSection
      hasElevesAffectes={hasElevesAffectes}
      elevesNonAffectes={elevesNonAffectes}
      conserverGroupes={conserverGroupes}
      handleModeChange={handleModeChange}
      isDisabled={isDisabled}
      classeNom={classeNom}
    />
    <div className="flex items-center justify-center mt-5 xl:mt-3 2xl:mt-4 3xl:mt-5 text-center">
      <button
        onClick={() => handleSubmit(true, conserverGroupes ? true : false)}
        className="bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white px-8 xl:px-6 2xl:px-7 3xl:px-8 py-4 xl:py-3 2xl:py-3.5 3xl:py-4 rounded-xl font-bold text-lg xl:text-sm 2xl:text-base 3xl:text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3"
      >
        <CheckCircle size={20} className="xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
        Valider
      </button>
    </div>
  </>
)} 
          </div>
          
        
        </> 
     
        </div>
    )

}


const RenderFormEvalNat = ({ evalfiltered, isFullEvalNat, handleNationalEval, isLoading }) => {
  // État de chargement
  if (isLoading) {
    return (
      <div className="group relative bg-white border-2 border-gray-200 rounded-xl p-5 sm:p-6 xl:p-4 2xl:p-5 3xl:p-6 transition-all duration-300">
        <div className="flex items-center gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
          <div className="w-10 h-10 xl:w-8 xl:h-8 2xl:w-9 2xl:h-9 3xl:w-10 3xl:h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <Loader2 className="w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-blue-500 animate-spin" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2 xl:mb-1.5 2xl:mb-1.5 3xl:mb-2">
              <BookOpen className="text-blue-400 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
              <span className="text-lg xl:text-sm 2xl:text-base 3xl:text-lg font-medium text-gray-400">Évaluation nationale</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-3 bg-gray-200 rounded animate-pulse w-3/4"></div>
            </div>
            <p className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-blue-500 mt-2 xl:mt-1.5 2xl:mt-1.5 3xl:mt-2 flex items-center gap-2">
              <Loader2 className="w-4 h-4 xl:w-3.5 xl:h-3.5 2xl:w-3.5 2xl:h-3.5 3xl:w-4 3xl:h-4 animate-spin" />
              Chargement des données...
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (evalfiltered.length === 0) {
    return (
      <div className="group relative bg-white border-2 text-lg xl:text-sm 2xl:text-base 3xl:text-lg
       border-gray-200 rounded-xl p-5 sm:p-6 xl:p-4 2xl:p-5 3xl:p-6 hover:border-blue-400 hover:shadow-lg transition-all duration-300
      ">
       Aucune évaluation nationale détectée
      </div>
    );
  }

  if (!isFullEvalNat) {
    return (
      <div className="flex items-center space-x-3 rounded-3xl border shadow-lg p-5 w-full
      bg-red-100 border-red-500">
        <p className=" text-red-700
        text-lg">Pas toutes les classes de cette barrette ont des résultats d'évaluations nationales.</p>
      </div>
    );
  }

  return (
    <div className="group relative bg-white border-2 border-gray-200 rounded-xl p-5 sm:p-6 xl:p-4 2xl:p-5 3xl:p-6 hover:border-blue-400 hover:shadow-lg transition-all duration-300">
       <div className="flex items-start gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
      <input
        type="radio"
        id="evaluationNationale"
        name="critereEvaluation"
        value="EvaluationNationale"
         className="mt-1 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-blue-600 border-2 border-gray-300 focus:ring-2 focus:ring-blue-500"
        onChange={(e) => handleNationalEval(e, evalfiltered)}
      />
      <label htmlFor="evaluationNationale" className="flex-1 min-w-0">
         <div className="flex items-center gap-2 mb-2 xl:mb-1.5 2xl:mb-1.5 3xl:mb-2">
          <BookOpen className="text-blue-500 w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
        <span className="block text-lg xl:text-sm 2xl:text-base 3xl:text-lg font-medium text-black dark:text-gray-300">
          Évaluation nationale
        </span>
        </div>
        <span className="block text-xs xl:text-[10px] 2xl:text-[11px] 3xl:text-xs text-gray-600">
          Les items de l'évaluation nationale donnés en début d'année seront sélectionnables pour composer vos groupes.
        </span>

      </label>
      </div>
    </div>
  );
};

// Composant réutilisable pour la section conservation/génération des groupes
const ConservationSection = ({ hasElevesAffectes, elevesNonAffectes, conserverGroupes, handleModeChange, isDisabled, classeNom }) => {
  if (classeNom) return null; // Ne pas afficher pour les classes individuelles (seulement barrettes)

  return (
    <>
      {hasElevesAffectes ? (
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 xl:p-4 2xl:p-5 3xl:p-6 mt-6 xl:mt-4 2xl:mt-5 3xl:mt-6 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
          <div className="flex items-start gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
            <div className="w-8 h-8 xl:w-7 xl:h-7 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">i</span>
            </div>
            <div>
              <p className="text-blue-900 font-semibold text-base sm:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
                {elevesNonAffectes && elevesNonAffectes.length > 0
                  ? `Des élèves sont déjà affectés à des groupes. ${elevesNonAffectes.length} élève(s) ne sont pas encore affectés et seront ajoutés au dernier groupe en mode conservation.`
                  : "Les élèves ont déjà été affectés à des groupes. La recomposition de vos groupes entraînera la réaffectation des élèves à de nouveaux groupes."
                }
              </p>
              <div className="space-y-3 xl:space-y-2 2xl:space-y-2.5 3xl:space-y-3 bg-white text-lg xl:text-sm 2xl:text-base 3xl:text-lg rounded-lg p-4 xl:p-3 2xl:p-3.5 3xl:p-4">
                <label className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 cursor-pointer hover:bg-gray-50 p-2 xl:p-1.5 2xl:p-2 3xl:p-2 rounded-lg transition-colors">
                  <input
                    type="radio"
                    id="conserver"
                    name="groupMode"
                    value="conserver"
                    onChange={handleModeChange}
                    checked={conserverGroupes}
                    disabled={isDisabled}
                    className="w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-blue-600"
                  />
                  <span className="text-gray-700">
                    Conserver les groupes existants
                    {elevesNonAffectes && elevesNonAffectes.length > 0 &&
                      <span className="text-orange-600 ml-1">(+{elevesNonAffectes.length} nouveaux élèves)</span>
                    }
                  </span>
                </label>
                <label className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 cursor-pointer hover:bg-gray-50 p-2 xl:p-1.5 2xl:p-2 3xl:p-2 rounded-lg transition-colors">
                  <input
                    type="radio"
                    id="nouveau"
                    name="groupMode"
                    value="nouveau"
                    onChange={handleModeChange}
                    checked={!conserverGroupes}
                    className="w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 text-blue-600"
                  />
                  <span className="text-gray-700">
                    Générer de nouveaux groupes
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-blue-50 border-2 text-lg xl:text-sm 2xl:text-base 3xl:text-lg border-blue-300 rounded-xl p-6 xl:p-4 2xl:p-5 3xl:p-6 mt-6 xl:mt-4 2xl:mt-5 3xl:mt-6 mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
          <div className="flex items-start gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
            <Info className="text-blue-600 flex-shrink-0 w-6 h-6 xl:w-5 xl:h-5 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6" />
            <div>
              <p className="text-blue-800 font-bold text-lg xl:text-sm 2xl:text-base 3xl:text-lg mb-2 xl:mb-1.5 2xl:mb-1.5 3xl:mb-2">
                Information
              </p>
              <p className="text-blue-700">
                Aucun élève de cette barrette n'est encore affecté à un groupe. De nouveaux groupes seront générés.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FormGroup;